export const findMeetingTimesConstants = {
    /**
     * Time suggestions search window begins these many days before the currently selected time
     */
    SEARCH_WINDOW_DAYS_BEFORE: 0,
    /**
     * Time suggestions search window ends these many days after the currently selected time
     */
    SEARCH_WINDOW_DAYS_AFTER: 7,

    /**
     * The minimum required confidence for a time slot to be returned in the response
     */
    MINIMUM_ATTENDEE_PERCENTAGE: 100,

    /**
     * The number of suggestions to return
     */
    MAX_CANDIDATES: 3,

    /**
     * The number of suggestions to return in quick compose
     */
    MAX_CANDIDATES_QUICK_COMPOSE: 2,

    /**
     * The number of suggestions to return in time panel
     */
    MAX_CANDIDATES_TIMEPANEL: 1,
};
